export { default as DiscussionsContainer } from "./DiscussionsContainer";
